function json(url, callback = () => {}) {
	if (!url) callback(null)
	const request = new XMLHttpRequest()
	request.addEventListener('readystatechange', event => {
		if (request.readyState !== 4) return
	    if (request.status == 200) return callback(JSON.parse(request.responseText))
		return callback(null)
	})
    request.open("GET", url, true)
    request.send(null)
}


function html(html) {
    const template = document.createElement('template')
    if ('content' in template) {
        template.innerHTML = html
        return document.importNode(template.content, true)
    }
    const frag = document.createDocumentFragment()
    const div = document.createElement('div')
    div.innerHTML = html
    while (div.firstChild) frag.appendChild(div.firstChild)
    return frag
}


function item({ url, image }) {
	return html(`
		<a target="_blank" href="${url}" class="social-item">
			<img src="${image}">
		</a>
	`)
}


export function socialFeed(el) {
	const feedId = el.getAttribute('data-feed-id').trim()
	const feedLength = parseInt(el.getAttribute('data-feed-length') || '10')
	if (!feedId) return

	json(`https://api.curator.io/v1/feeds/${feedId}/posts`, function(response) {
		const latest = response
			?.posts
			?.filter(post => post.has_image && !post.is_deleted)
			.slice(0, feedLength)

		latest.map(post => el.appendChild(item(post)))		
	})
}